import { FunctionComponent } from 'react';
import { CONTAINER_ID } from '../engage-constants';
import { Iframe } from './engage-iframe.styles';

interface IEngageIframeProps {
  accessToken: string;
  engageOrigin: string;
}

export const EngageIframe: FunctionComponent<IEngageIframeProps> = ({
  accessToken,
  engageOrigin,
}) => {
  const pathName = window.location.pathname.replace(/\/engage\/?/, '');
  const pathHash = window.location.hash;
  const internalOriginUrl = `${engageOrigin}/${pathName}?accessToken=${accessToken}${pathHash}`;

  return (
    <Iframe
      key={accessToken}
      id={CONTAINER_ID}
      src={internalOriginUrl}
      data-e2e="engage-iframe"
    ></Iframe>
  );
};
